<template>
  <nav v-if="linked && linked.length > 0">
    <country-link
      :link="link + removeLocale(additionalPath)"
      :country="country"
      name="Your current page is"
      :country-name="countryName(country)"
      :title="`Current page in ${countryName(country)}`"
    />
    <country-link
      v-for="l in linked"
      :key="l.id"
      :link="l.link + removeLocale(additionalPath)"
      :country="l.country"
      :country-name="countryName(l.country)"
      :name="l.name"
      :title="`Go to ${countryName(l.country)} version of ${l.name}`"
    />
  </nav>
</template>
<script>
import CountryLink from '~/components/CountryLink.vue';
import { removeLocale as rmLocale } from '~/utils/formatStrings';
/**
 * Display countries to switch between. Note: if the linked array is empty, this component will not render.
 */
export default {
  name: 'CountrySwitcher',
  components: {
    CountryLink,
  },
  props: {
    linked: {
      type: Array,
      default: () => [],
    },
    link: {
      type: String,
      required: true,
    },
    country: {
      type: String,
      default: undefined,
    },
    additionalPath: {
      type: String,
      default: '',
    },
  },
  methods: {
    removeLocale(s) {
      return rmLocale(s);
    },
    countryName(country) {
      return this.$i18n.locales.find(({ code }) => code === country)?.name ?? country;
    },
  },
};
</script>
<style scoped lang="scss">
nav {
  display: flex;
  flex-direction: column;
  margin: 1em;
  max-width: calc(100vw - 2em);
  gap: 0.5rem;
}
@media #{$large-up} {
  nav {
    flex-direction: row;
    justify-content: center;
    gap: 1rem;
    margin: 2em;
  }
}
</style>
